import React, { useState } from "react";
import {Dialog} from 'primereact/dialog';
import GenericUI from "../generic.ui";
import {Translator} from "../../translator";
import { AuthenticationAPI } from "../../../api/authentication";

//import "./styles/smartphone.css";
//import "./styles/tablet.css";
import "./styles/desktop.css";

export default class AccountPanel extends GenericUI
{
    constructor( props ) {
        super( props );
        this.state = {
            visible: props.visible,
            account: undefined
        };
    }

    componentDidMount()
    {
        window.AccountPanel = this;
    }

    logout(e)
    {
        if( window.ConfirmDialogBox )
        {
            window.ConfirmDialogBox.show( 'confirm_logout', 'logout_confirm_message', () => {
                if( window.localStorage) localStorage.clear();
                if( window.sessionStorage) sessionStorage.clear();
                window.open('index.html', '_self');
            } );
        }
    }

    loadCurrentAccount()
    {
        AuthenticationAPI.getCurrentAccount()
            .then( ( response ) => {
                if( response && response.data && response.data.account )
                {
                    this.setState( { visible: true, account: response.data.account } );
                }
            } )
        .catch( ( error ) => {
            if( window.Messenger )
            {
                window.Messenger.showMessage( 'error', error );
            }
        });
    }

    render()
    {
        super.render();
/**
 *                                     <tr>
                                        <td className="td-left label">{Translator.get("AI Secret Key")}</td>
                                        <td className="td-right"><input type="text" defaultValue="" placeHolder={Translator.get("enter_your_ai_secret_key")} /></td>
                                    </tr>

 */
        if( this.state.visible )
        {
            return(
                <div className="mask">
                    <Dialog
                        modal
                        visible={this.state.visible}
                        onHide={() => this.setState( { visible: false } ) }
                        header={Translator.get("account_preferences")}
                        className="account-panel no-text-select"
                    >
                        <div className="account-form">
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="td-left label">{Translator.get("firstname")}</td>
                                        <td className="td-right"><input type="text" id="firsname" value={this.state.account.firstname} /></td>
                                    </tr>
                                    <tr>
                                        <td className="td-left label">{Translator.get("lastname")}</td>
                                        <td className="td-right"><input type="text" id="lastanme" value={this.state.account.lastname} /></td>
                                    </tr>
                                    {/*<tr>
                                        <td className="td-left label">{Translator.get("AI Secret Key")}</td>
                                        <td className="td-right"><input type="text" id="ai_key" value={this.state.account['ai_key']} /></td>
                                    </tr>*/}
                                    <tr>
                                        <td colspan="2"><hr /></td>
                                    </tr>
                                    <tr>
                                        <td className="td-left label">{Translator.get("email")}</td>
                                        <td className="td-right">{this.state.account.email}</td>
                                    </tr>                                                                        
                                    <tr>
                                        <td className="td-left label">{Translator.get("current_licence")}</td>
                                        <td className="td-right">{Translator.get(this.state.account.licence)}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>&nbsp;</div>
                        <div className="account-buttons">
                            <button className="logout" onClick={(e)=>{this.logout(e)}}>{Translator.get("logout")}</button>
                            <a href="#">{Translator.get("delete_account")}</a>

                            <button className="cancel" onClick={() => this.setState( { visible: false } )}>{Translator.get("cancel")}</button>
                            <button className="save" style={{cursor: 'not-allowed', filter: 'brightness(0.5)'}}>{Translator.get("save")}</button>
                            
                            {/*<button style={{cursor: 'not-allowed', filter: 'brightness(0.5)'}} className="unregister">{Translator.get("delete_account")}</button>*/}
                        </div>
                    </Dialog>
                </div>
            );
        }
        else
        {
            return null;
        
        }
    }
}